import main from './main'

export default {
  ...main,
  
  baseURL: "https://api.apartments-test.jarvis.oohdesk.ru",
  debug: true,
}
  